export const ALERT_HEADLINES_REFETCH_INTERVAL = 90000;
export const MAP_TILE_INVENTORY_REFETCH_INTERVAL = 300000;
export const GRID_INVENTORY_REFETCH_INTERVAL = 900000;
export const LIGHTNING_REFETCH_INTERVAL = 300000;

//storage keys
export const USER_SETTINGS_KEY = 'USER_SETTINGS';
export const ADOBE_API_TOKEN_KEY = 'ADOBE_API_TOKEN';
export const DSP_ACCESS_TOKEN_KEY = 'DSP_ACCESS_TOKEN';
export const DEVICE_ID_KEY = 'DEVICE_ID';
export const DSP_CLIENT_TOKEN_KEY = 'DSP_CLIENT_TOKEN_KEY';
export const CURRENT_LIVE_VIDEO_STREAM = 'CURRENT_LIVE_VIDEO_STREAM';
export const ENVIRONMENT = 'ENVIRONMENT';
export const STORAGE_APP_INSTALLED = 'TWC_APP_INSTALLED';
